import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import { Wrapper, RightSection } from './header.styled';
import { useResponsive } from '../../../../hooks';
import { MobileApp } from '../mobile-app';
import { Phone } from '../phone';
import { getPublicRequestData } from '../../selectors';
import { Button, Text, Dropdown } from '../../components-v4';
import { ReactComponent as TelegramIcon } from '../../assets/Telegram-icon.svg';
import { ReactComponent as MaxIcon } from '../../assets/max-icon.svg';

export const Header: FC = memo(() => {
  const { viewport } = useResponsive();
  const requestData = useSelector(getPublicRequestData);

  const goTelegram = () => {
    window.open(
      'https://t.me/arseniy_kabinet_bot/',
      '_blank',
      'noopener noreferrer'
    );
  };

  const goMax = () => {
    window.open(
      'https://max.ru/id7806206017_bot',
      '_blank',
      'noopener noreferrer'
    );
  };

  return (
    <Wrapper isTablet={viewport.tablet}>
      <Text variant={viewport.tablet ? 'heading-2' : 'heading-3'}>
        № {requestData.request_number}
      </Text>
      <RightSection>
        {viewport.desktop && (
          <>
            <MobileApp />
            <Dropdown.Root>
              <Dropdown.Trigger>
                <Button mode="accent" variant="ghost" size="s">
                  Чат-бот «Арсений»
                </Button>
              </Dropdown.Trigger>

              <Dropdown.Content
                side="bottom"
                align="end"
                style={{ width: 240 }}
              >
                <Dropdown.Item onClick={goMax}>
                  <MaxIcon />
                  <Text>Бот в MAX</Text>
                </Dropdown.Item>
                <Dropdown.Item onClick={goTelegram}>
                  <TelegramIcon />
                  <Text>Бот в Telegram</Text>
                </Dropdown.Item>
              </Dropdown.Content>
            </Dropdown.Root>
          </>
        )}
        {viewport.mobile && (
          <Phone
            phoneNumbers={requestData.dispatcher_phones}
            inHeader={true}
          />
        )}
      </RightSection>
    </Wrapper>
  );
});
